import { useRef } from 'react'
import { useModalDialog } from '../../../hooks'
import { ClientEditForm } from '../components/ClientEditForm'

export const useClientCaseDialog = () => {

  const { showModalDialog, hideModalDialog, setLoadingModalDialog } = useModalDialog()
  const dialogRef = useRef({ submit: () => Promise.resolve() })

  // "Ny kund" / "Redigera kund" as a pop-up (was its own /new page, then a
  // separate /:slug/edit page) — same dialogRef/submit contract as network's
  // useNetworkDialog.showPersonDialog/showCompanyDialog. Pass an existing
  // client to edit it, or omit it to create a new one. onSaved is called with
  // the created/updated client row.
  const showClientDialog = (client, onSaved) => {
    showModalDialog({
      title: client ? 'Redigera kund' : 'Ny kund',
      Content: () => (
        <ClientEditForm
          client={client}
          dialogRef={dialogRef}
          hideModalDialog={hideModalDialog}
          setLoadingModalDialog={setLoadingModalDialog}
          onSaved={onSaved}
        />
      ),
      submitLabel: 'Spara',
      submitLabelLoading: 'Sparar...',
      cancelLabel: 'Avbryt',
      onSubmit: () => dialogRef.current.submit(),
      onCancel: hideModalDialog,
    })
  }

  const showDeleteClientCaseDialog = (data, onSubmit) => {

    const config = {
      title: "Ta bort kundcase",
      Content: () => <div>Detta tar permanent bort <strong>{data.client_name || data.slug}</strong>.</div>,
      onSubmit: () => onSubmit(data),
      submitLabelLoading: "Tar bort...",
    }

    showModalDialog(config)
  }

  const showDeleteReviewDialog = (data, onSubmit) => {

    const config = {
      title: "Ta bort utvärdering",
      Content: () => <div>Detta tar permanent bort utvärderingen för <strong>{data.period}</strong> för <strong>{data.clientName}</strong>.</div>,
      onSubmit: () => onSubmit(data),
      submitLabelLoading: "Tar bort...",
    }

    showModalDialog(config)
  }

  // Client delete cascades to reviews and contacts (dialog warns), but is
  // RESTRICTed by the API while the client still has cases.
  const showDeleteClientDialog = (data, onSubmit) => {

    const config = {
      title: "Ta bort kund",
      Content: () => (
        <div>
          Detta tar permanent bort <strong>{data.company_name}</strong> som kund, inklusive alla utvärderingar och kontakter.
          {data.case_count > 0 && <p style={{ color: 'var(--color-intense-red)', marginTop: 8 }}>Kunden har {data.case_count} case — ta bort dem först.</p>}
        </div>
      ),
      onSubmit: () => onSubmit(data),
      submitLabelLoading: "Tar bort...",
    }

    showModalDialog(config)
  }

  const showRemoveContactDialog = (data, onSubmit) => {

    const config = {
      title: "Ta bort kontakt",
      Content: () => <div>Detta tar bort <strong>{data.person_name}</strong> som kontakt hos kunden.</div>,
      onSubmit: () => onSubmit(data),
      submitLabelLoading: "Tar bort...",
    }

    showModalDialog(config)
  }

  return {
    showClientDialog,
    showDeleteClientCaseDialog,
    showDeleteReviewDialog,
    showDeleteClientDialog,
    showRemoveContactDialog,
  }
}
